import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=2d5bc7c8&scoped=true"
import script from "./toolbar.vue?vue&type=script&lang=js"
export * from "./toolbar.vue?vue&type=script&lang=js"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=2d5bc7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5bc7c8",
  null
  
)

export default component.exports